import { PersonalCodeResult } from '@app/lib/personal-code/model/PersonalCodeResult';

function isValidDate(year: number, month: number, day: number): boolean {
    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
}

function calculateChecksum(digits: number[]): number {
    const weights1 = [1, 2, 3, 4, 5, 6, 7, 8, 9, 1];
    const weights2 = [3, 4, 5, 6, 7, 8, 9, 1, 2, 3];

    const calculateSum = (weights: number[]): number =>
        digits.slice(0, 10).reduce((acc, digit, i) => acc + digit * weights[i], 0);

    const remainder1 = calculateSum(weights1) % 11;
    if (remainder1 < 10) {
        return remainder1;
    }

    const remainder2 = calculateSum(weights2) % 11;
    return remainder2 < 10 ? remainder2 : 0;
}

export function parseLithuanianPersonalCode(personalCode: string): PersonalCodeResult {
    if (!/^\d{11}$/.test(personalCode)) {
        return { isValid: false };
    }

    const firstDigit = parseInt(personalCode[0]);

    if (![3, 4, 5, 6].includes(firstDigit)) {
        return { isValid: false };
    }

    const digits = personalCode.split('').map(Number);
    const expectedChecksum = calculateChecksum(digits);
    const actualChecksum = digits[10];

    if (expectedChecksum !== actualChecksum) {
        return { isValid: false };
    }

    const year = parseInt(personalCode.substring(1, 3));
    const month = parseInt(personalCode.substring(3, 5));
    const day = parseInt(personalCode.substring(5, 7));
    let century: number;
    const gender: 'male' | 'female' = firstDigit % 2 === 1 ? 'male' : 'female';

    switch (firstDigit) {
        case 3:
        case 4:
            century = 1900;
            break;
        case 5:
        case 6:
            century = 2000;
            break;
        default:
            return { isValid: false };
    }

    const fullYear = century + year;

    if (!isValidDate(fullYear, month, day)) {
        return { isValid: false };
    }

    const monthStr = personalCode.substring(3, 5);
    const dayStr = personalCode.substring(5, 7);
    const birthDate = `${fullYear}-${monthStr}-${dayStr}`;
    const today = new Date();
    const birthDateObj = new Date(fullYear, month - 1, day);
    let age = today.getFullYear() - birthDateObj.getFullYear();
    const monthDiff = today.getMonth() - birthDateObj.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDateObj.getDate())) {
        age--;
    }

    return {
        isValid: true,
        year: fullYear,
        age,
        gender,
        birthDate,
    };
}
